<form>
  <mat-form-field data-cy="cm-input-field"
                  class="cm-custom-text-field {{ 'density-' + density }} w-100"
                  [ngClass]="{
                  'text-field-has-error' :
                  control?.touched && control?.dirty && control?.invalid || ((!control || errors) && value && errorMessage),
                  'form-field' : isFormField,
                  'cm-text-field--textarea' : !!rows,
                  'ng-invalid mat-form-field-invalid' :
                  (errors && errorMessage) || hasControlErrors || (!control && errorMessage && value !=null) || min && +value < +min,
      'cm-form-field-readonly': readonly
    }"
    [appearance]="mode"
    [floatLabel]="label ? 'auto' : 'never'"
  >
    <mat-label *ngIf="label">{{ label | translate }}</mat-label>
    <!-- Input field -->
    <input
      matInput
      [attr.data-cy]="dataCy ?? 'cm-input-field-input'"
      #inputEl
      #input="ngModel"
      *ngIf="!rows && type !== 'datepicker' && type !== 'datepickerRange'"
      [ngModel]="value"
      name="{{value}}"
      [placeholder]="placeholder | translate"
      [readonly]="readonly"
      [required]="required"
      [disabled]="disabled"
      [maxlength]="maxLength"
      [min]="min"
      [max]="max"
      [type]="type || 'text'"
      [errorStateMatcher]="errorMatcher()"
      (ngModelChange)="value = $event; onChange($event); valueChange.emit(value)"
      (blur)="blur($event)"
      (focusin)="focusIn($event)"
      (keyup.enter)="onEnter.emit()"
      [attr.tabindex]="tabIndex"
      cmOnlyNumbers
      [ngModelOptions]="{standalone: true}"
    />

    <!-- Datepicker field -->
    <input
      matInput
      [attr.data-cy]="dataCy ?? 'cm-input-field-input'"
      #inputEl
      #input="ngModel"
      *ngIf="type === 'datepicker'"
      [ngModel]="value"
      [placeholder]="placeholder | translate"
      [required]="required"
      [disabled]="disabled"
      [maxlength]="maxLength"
      [type]="type || 'text'"
      [min]="minDate"
      [max]="maxDate"
      [matDatepicker]="cmDatepicker"
      [errorStateMatcher]="errorMatcher()"
      (ngModelChange)="value = $event; onChange($event); valueChange.emit(value)"
      (blur)="blur($event)"
      (focusin)="focusIn($event)"
      (keyup.enter)="onEnter.emit()"
      [attr.tabindex]="tabIndex"
      [ngModelOptions]="{standalone: true}"
    />

    <mat-datepicker-toggle
      class="cm-input-field-datepicker-icon"
      *ngIf="type === 'datepicker'"
      matSuffix
      [for]="cmDatepicker"
      [ngModelOptions]="{standalone: true}"
    >
      <mat-icon [attr.data-cy]="dataCy + '-button'" matDatepickerToggleIcon>calendar_today</mat-icon>
    </mat-datepicker-toggle>
    <mat-datepicker #cmDatepicker [disabled]="type !== 'datepicker' || readonly || disabled"></mat-datepicker>

    <!-- DatePicker Range field -->
    <mat-date-range-input
      data-cy="cm-input-field-date-range"
      *ngIf="type === 'datepickerRange'"
      class="cm-input-field-date-range"
      placeholder="range"
      [rangePicker]="pickerRange"
      [min]="minDate"
      [max]="maxDate"
      [ngModelOptions]="{standalone: true}"
    >
      <input
        matStartDate
        data-cy="cm-input-field-start-date"
        class="cm-input-field-start-date"
        [ngModel]="startDate"
        (ngModelChange)="onStartDateChange($event)"
        [ngModelOptions]="{standalone: true}"
      />
      <input
        matEndDate
        data-cy="cm-input-field-end-date"
        class="cm-input-field-end-date"
        [ngModel]="endDate"
        (ngModelChange)="onEndDateChange($event)"
        [ngModelOptions]="{standalone: true}"
      />
    </mat-date-range-input>
    <mat-datepicker-toggle
      class="cm-input-field-datepicker-icon"
      *ngIf="type === 'datepickerRange'"
      matSuffix
      [for]="pickerRange"
      [ngModelOptions]="{standalone: true}"
    >
      <mat-icon matDatepickerToggleIcon> calendar_today </mat-icon>
    </mat-datepicker-toggle>
    <mat-date-range-picker #pickerRange [disabled]="type !== 'datepickerRange'"></mat-date-range-picker>

    <!-- Textarea field -->
    <textarea
      cdkTextareaAutosize
      *ngIf="rows"
      matInput
      [attr.data-cy]="dataCy ?? 'cm-input-field-textarea'"
      #inputEl
      #input="ngModel"
      [rows]="rows"
      [cdkAutosizeMinRows]="rows"
      [cdkAutosizeMaxRows]="textareaAutosize ? null : rows"
      [required]="required"
      [readonly]="readonly"
      [placeholder]="placeholder | translate"
      [maxlength]="maxLength"
      [disabled]="disabled"
      [ngModel]="value"
      [errorStateMatcher]="errorMatcher()"
      (ngModelChange)="value = $event; onChange($event); valueChange.emit(value)"
      (blur)="blur($event)"
      (focusin)="focusIn($event)"
      (keyup.enter)="onEnter.emit()"
      [ngModelOptions]="{standalone: true}"
    ></textarea>

    <cm-icon-button
      [disabled]="disabled"
      dataCy="cm-custom-text-field-left-icon"
      *ngIf="leftIcon"
      matPrefix
      [icon]="leftIcon"
      (clickEvent)="leftIconOnClick.emit()"
      [hasRipple]="leftIconHasRipple"
      [iconMode]="leftIconMode"
      [color]="leftIconColor"
      [size]="leftIconSize"
      [density]="density"
    >
    </cm-icon-button>
    <cm-icon-button
      [disabled]="disabled"
      dataCy="cm-custom-text-field-right-icon"
      *ngIf="rightIcon"
      matSuffix
      [icon]="rightIcon"
      (clickEvent)="rightIconOnClick.emit()"
      [hasRipple]="rightIconHasRipple"
      [iconMode]="rightIconMode"
      [color]="rightIconColor"
      [size]="rightIconSize"
      [density]="density"
    ></cm-icon-button>

    <mat-icon
      id="rightIndicator"
      *ngIf="rightIndicator"
      matTooltipClass="cm-tooltip typography__tooltip"
      matTooltipShowDelay="500"
      matTooltipPosition="below"
      [matTooltipDisabled]="isMobileView"
      [matTooltip]="tooltip"
      (click)="rightIconOnClick.emit()"
      matSuffix
      [class]="rightIndicatorClass"
      >{{ rightIndicator }}</mat-icon
    >
  </mat-form-field>
  <div class="cm-input-field__helper-area">
    <mat-error class="cm-error-message position-relative"
               *ngIf="
        (control?.hasError('required') && touched) ||
        (errors?.required && errorMessage === 'required')
      "
               data-cy="required-error-msg">
      {{ name || label || 'form.this-field' | translate }} {{ 'form.isRequired' | translate }}.
    </mat-error>
    <mat-hint class="cm-error-message" *ngIf="errors?.requiredCostCenterValue">
      {{ 'crib.cost-center-value' | translate }} {{ 'form.isRequired' | translate }}.
    </mat-hint>
    <mat-error class="cm-error-message" *ngIf="control?.hasError('pattern')">
      {{ label || 'form.this-field' | translate }} {{ 'form.isInvalid' | translate }}.
    </mat-error>
    <mat-error class="cm-error-message" *ngIf="control?.hasError('maxlength')">
      {{ label || 'form.this-field' | translate }} {{ 'form.exceedsMaxLength' | translate }}.
    </mat-error>
    <mat-error class="cm-error-message" *ngIf="control?.hasError('min')">
      {{ label || 'form.this-field' | translate }} {{ 'form.minValueValidator' | translate }}.
    </mat-error>
    <mat-error class="cm-error-message" *ngIf="control?.hasError('max')">
      {{ label || 'form.this-field' | translate }} {{ 'form.maxValueValidator' | translate }}.
    </mat-error>
    <mat-error class="cm-error-message" *ngIf="control?.hasError('min')"> {{ minErrorMessage | translate }} </mat-error>
    <mat-hint class="cm-hint-input-message" *ngIf="hint && !errorMessage && !hasControlErrors">{{ hint }}</mat-hint>
    <mat-hint class="cm-error-message position-relative text-nowrap"
              *ngIf="(errors && errorMessage) ||  (!control && errorMessage && value != null)">
      {{ errorMessage | translate }}
    </mat-hint>
    <!-- show me only on textarea's with max length -->
    <mat-hint class="cm-maxlength-message" *ngIf="showMaxLength && !errors && !hasControlErrors">
      {{ 'string.maxCharacters' | translate }} {{ value?.length ?? 0 }}/{{ maxLength }}
    </mat-hint>
  </div>
</form>
